import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import List from 'components/shared/List'
import { useAppSelector } from 'store/hooks'
import useCityBreak from 'components/common/CityBreak/utils/useCityBreak'

export const CityBreakDetails = () => {
    const {
        isCityBreakApplicableForAccommo,
        isCityBreakDealingWithParkTickets,
    } = useCityBreak()
    const {
        guestsToAssign: { infants },
    } = useAppSelector((state) => state.accommodation)

    return (
        <Box gap={12}>
            <Text variant="heading3" color="grayscale_900">
                <FormattedMessage
                    id="promo.city_break.detailed_info_title"
                    defaultMessage="_"
                />
            </Text>
            <List color="grayscale_800" isBulletCentered>
                {isCityBreakDealingWithParkTickets ? (
                    <FormattedMessage
                        id="promo.city_break.detailed_info_description_tickets_deleting"
                        defaultMessage="_"
                    />
                ) : (
                    <FormattedMessage
                        id="promo.city_break.detailed_info_description_1"
                        defaultMessage="_"
                    />
                )}
                <FormattedMessage
                    id="promo.city_break.detailed_info_description_2"
                    defaultMessage="_"
                />
                <FormattedMessage
                    id="promo.city_break.detailed_info_description_3"
                    defaultMessage="_"
                />
                {infants > 0 ? (
                    <>
                        {isCityBreakApplicableForAccommo ? (
                            <FormattedMessage
                                id="promo.city_break.detailed_info_description_infants_for_accommo"
                                defaultMessage="_"
                            />
                        ) : (
                            <FormattedMessage
                                id="promo.city_break.detailed_info_description_infants_for_tickets"
                                defaultMessage="_"
                            />
                        )}
                    </>
                ) : undefined}
            </List>
        </Box>
    )
}
